import { Slider } from 'antd';
import React from 'react';
import moment from 'moment-timezone';
import { RouteLocation } from 'types/common.consts';
import './mabox-route-tracker-slider.scss';

interface Props {
	routeLocations: RouteLocation[];
	routeIndex: number;
	onChangeRouteIndex: (newIndex) => void;
	timeFormat: string;
	disabled: boolean;
	timeZone?: string;
}

const MapboxRouteTrackerSlider: React.FC<Props> = ({
	routeLocations: route,
	routeIndex,
	onChangeRouteIndex,
	timeFormat,
	timeZone,
	disabled
}) => {
	const sliderValue = (routeIndex / (route.length - 1)) * 100;

	const getTooltipPopupContainer = triggerNode => {
		return triggerNode;
	};
	const onChanged = value => {
		onChangeRouteIndex(Math.round((value * (route.length - 1)) / 100));
	};

	const tooltipFormatter = () => {
		const happendAtTime = moment(route[routeIndex]?.happened_at);
		return timeZone ? happendAtTime.tz(timeZone).format(timeFormat) : happendAtTime.format(timeFormat);
	};

	return (
		<Slider
			className="mapbox-route-tracker-slider"
			defaultValue={sliderValue}
			value={sliderValue}
			max={100}
			onChange={onChanged}
			tooltip={{ open: !disabled, formatter: tooltipFormatter, getPopupContainer: getTooltipPopupContainer }}
			disabled={disabled}
		/>
	);
};

export default MapboxRouteTrackerSlider;
